module.exports = __webpack_public_path__ + "static/media/cloud-d-v3@2x.c403c0f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-d-v3@2x.png
// module id = 99
// module chunks = 0